/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('terminalCtrl', ['$rootScope', '$scope', '$http', 'NetworkService', 'CmdService', function ($rootScope, $scope, $http, NetworkService, CmdService) {

        $scope.commands = []

        $scope.validCommand = ["show"]
        $scope.lineCount = 0
        $scope.split = function (line)
        {
            var cmds = line.split(" ")
            return cmds
        }


        $scope.hide = function ()
        {
            //$("#terminal").fadeOut()
        }

        $scope.isValidCmd = function (cmd)
        {
            return $scope.validCommand.indexOf(cmd) != -1
        }
        $scope.focusInput = function ()
        {
            $("#terminalInput").get(0).focus()
        }
        $scope.command = ""


        $scope.input = function ($e)
        {
            if ($e.keyCode == 13)
            {

                $scope.commands.push($scope.command)
                var cmd = $scope.split($scope.command)

                switch (cmd[0])
                {
                    case "show":
                        if (cmd[1] == "errors")
                        {
                            var errors = CmdService.getErrors()
                        }else
                        {
                            var errors = CmdService.getLogs()
                        }
                        errors.forEach(function (error)
                        {
                            $scope.lineCount++;
                            $scope.commands.push($scope.lineCount + ": " + error)
                            console.log(error)
                        })
                        break;
                    case "connect":
                        $scope.commands = []
                        $scope.commands.push("connecting...")
                        break;
                    case "clear":
                        $scope.commands = []
                        break;
                    default:
                        $scope.commands.push("Ungültiger Befehl")
                }
                $scope.command = "";
            }
        }
    }]);